import { Component, inject, Input } from '@angular/core';
import { EcoScoreService } from 'src/app/shared/services/eco-score.service';

@Component({
  selector: 'app-ecoscore',
  templateUrl: './ecoscore.component.html',
  styleUrl: './ecoscore.component.scss',
  standalone: true,
  imports: [],
})
export class EcoscoreComponent {
  @Input() ecoScore?: number;
  ecoScoreService = inject(EcoScoreService);
}
